<template>
  <div>
    <yxt-row class="bg-white">
      <yxt-col>
        <yxt-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <yxt-form-item :label="$t('pc_biz_ote_lbl_examname')" prop="name">
            <yxt-input v-model="ruleForm.name" :placeholder="$t('pc_biz_ote_tip_examnametip')" style="width:100%" :disabled="status !== 0"  show-word-limit :maxlength="200"></yxt-input>
          </yxt-form-item>
          <!-- 考试限制 -->
          <yxt-form-item class="color-gray-9" :label="$t('pc_biz_ote_lbl_entertime')">
            <yxt-checkbox v-model="isEntryTimeCtrl" class="">{{ $t('pc_biz_ote_lbl_entertimelimit') }}</yxt-checkbox>
            <span class="ml10" v-if="isEntryTimeCtrl">
              <yxt-date-picker
                v-model="entryTime"
                type="datetimerange"
                :range-separator="$t('pc_biz_ote_lbl_to')"
                :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:440px"
                >
              </yxt-date-picker>
            </span>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_exampaper')" prop="examName">
            <yxt-button type="primary" @click="openSelectExamDrawer()" :disabled="status !== 0">{{ $t('pc_biz_ote_btn_selectpaper') }}</yxt-button>
            <!-- <yxt-button  @click="quickExam()" :disabled="status !== 0">快速出卷</yxt-button> -->
            <span class="color-gray-6 ml10" v-if="ruleForm.examName">{{ruleForm.examName}}，{{ $t('pc_biz_ote_lbl_totalscore', [ruleForm.totalScore]) }}<span v-if="status === 0" class="hand ml5 color-gray-6" @click="deleteExam()"><yxt-svg width="16px" height="16px" icon-class="close" class="hover-primary-6 hand yxtbiz-exam-arrange__tip-icon-t3"/></span></span>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_passscore')" prop="passScore">
            <yxt-input  v-model="ruleForm.passScore" autocomplete="off" :placeholder="$t('pc_biz_ote_tip_scoreinputtip')" v-enter-float  style="width:96px" :disabled="status !== 0" :maxlength="3"></yxt-input>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_goodscore')" prop="excellenceScore">
            <yxt-input  v-model="ruleForm.excellenceScore" autocomplete="off" :placeholder="$t('pc_biz_ote_tip_scoreinputtip')" v-enter-float  style="width:96px" :disabled="status !== 0" :maxlength="3"></yxt-input>
          </yxt-form-item>
          <yxt-form-item v-if="(reward || masterType !== 3)" :label="$t('pc_biz_ote_lbl_rewardsetting')">
            <div v-if="reward">
              <!-- 已有学员参与不支持修改学分、积分、证书 -->
              <yxt-checkbox v-model="ruleForm.isPassedCredit" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_passtogetstudyscore') }}</yxt-checkbox>
              <yxt-input v-if="ruleForm.isPassedCredit" :maxlength="5" v-model="ruleForm.passedCredit" autocomplete="off" class="mh8" style="width:96px" :disabled="status !== 0" v-enter-float></yxt-input>
            </div>
            <div v-if="reward" class="mt10">
              <yxt-checkbox v-model="ruleForm.isPassedPoint" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_passtogetscore') }}</yxt-checkbox>
              <yxt-input v-if="ruleForm.isPassedPoint" :maxlength="5" v-model="ruleForm.passedPoint" autocomplete="off" class="mh8" style="width:96px" :disabled="status !== 0" v-enter-number></yxt-input>
            </div>
            <div v-if="masterType !== 3 && !oteCerStatus.hidden" :class="reward ? 'mt10' : ''">
              <yxt-checkbox v-model="isIssueCer" :disabled="status !== 0 || oteCerStatus.disabled">
                {{ $t('pc_biz_ote_lbl_passtogetcer') }}
                <yxt-tooltip effect="dark" :content="$t('pc_biz_ote_tip_passtogetcertip')" placement="top">
                  <span class="ml8 v-mid"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip>
              </yxt-checkbox>
              <div class="ml20" v-if="isIssueCer">
                <yxt-button type="primary" @click="openSelectCerDrawer()" :disabled="status !== 0">{{ $t('pc_biz_ote_btn_selectcer') }}</yxt-button>
                <span class="color-gray-6 mh8" v-if="ruleForm.cerName">{{ruleForm.cerName}}<span  v-if="status === 0" class="ml5 color-gray-6" @click="deleteCer()"><yxt-svg width="16px" height="16px" icon-class="close" class="hover-primary-6 hand yxtbiz-exam-arrange__tip-icon-t3"/></span></span>
              </div>
            </div>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_examdesc')" prop="description">
            <yxt-input type="textarea" :placeholder="$t('pc_biz_ote_tip_examdescinput')" rows="5" v-model="ruleForm.description" autocomplete="off" style="width:100%;" :maxlength="200"></yxt-input>
          </yxt-form-item>
        </yxt-form>
      </yxt-col>
    </yxt-row>
    <yxt-drawer
      ref="selector"
      :title="$t('pc_biz_ote_btn_selectpaper')"
      size="960px"
      append-to-body
      modal-append-to-body
      :visible.sync="selectExamDrawerData.isShowSelectExamDrawer"
      :destroy-on-close="true"
      :direction="'rtl'"
      :before-close="()=>{saveExamSelect(true)}"
    >
      <yxtbiz-exam-selector :functionCode="functionCode" :dataPermissionCode="dataPermissionCodes.selectExam" v-model="selectExamDrawerData.exam" :type="(masterType === 1 || masterType === 3) ? 0 : 1" @select="saveExamSelect()"></yxtbiz-exam-selector>
    </yxt-drawer>
    <yxt-drawer :title="$t('pc_biz_ote_btn_selectcer')" 
      :visible.sync="selectCerDrawerData.isShowSelectCerDrawer"
      size="640px" 
      :direction="'rtl'">
      <yxtbiz-certificate-selector :functionCode="functionCode" :dataPermissionCode="dataPermissionCodes.selectCer" v-model="selectCerDrawerData.cer"></yxtbiz-certificate-selector>
      <div slot="footer">
        <yxt-button plain @click="cancleCerSelect()">{{ $t('pc_biz_ote_btn_cancle') }}</yxt-button>
        <yxt-button type="primary" @click="saveCerSelect()">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>
<script>
import {
  Drawer,
  Form,
  FormItem,
  Tooltip,
  DatePicker
} from 'yxt-pc';
import YxtbizCertificateSelector from 'yxt-biz-pc/packages/certificate-selector';
import YxtbizExamSelector from 'yxt-biz-pc/packages/exam-selector';
import { resetValueBystatus, getFunStatus } from '../../../common-util/factorUtils';
import { enmuFunctions } from '../../../function-points';
export default {
  name: 'arrangeBaseInfo',
  components: {
    YxtbizCertificateSelector,
    YxtbizExamSelector,
    YxtDrawer: Drawer,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtTooltip: Tooltip,
    YxtDatePicker: DatePicker
  },
  props: {
    id: {
      type: String,
      required: false
    },
    arrange: {
      type: Object,
      default: () => { return {}; }
    },
    masterId: {
      type: String,
      required: false
    },
    masterName: {
      type: String,
      required: true
    },
    /**
     * 0、普通考试；1、项目考试；2、课程包考试；
     */
    masterType: {
      type: Number,
      required: true
    },
    // 奖励
    reward: {
      type: Boolean,
      required: true
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCodes: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let vm = this;
    const validateExamTime = (rule, value, callback) => {
      let currentTime = new Date();
      let startTime = null;
      let endTime = null;
      if (this.isEntryTimeCtrl) {
        if (!this.entryTime || this.entryTime.length <= 1) {
          callback(new Error(this.$t('pc_biz_ote_msg_examentertimenotnull')));
          return;
        }
        startTime = new Date(this.entryTime[0].replace(/-/g, '/'));
        endTime = new Date(this.entryTime[1].replace(/-/g, '/'));
        if (endTime < currentTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_endtimemustlasternow')));
          return;
        }
        if (startTime > endTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_endtimemustlasterstarttime')));
          return;
        }
      }
      callback();
    };
    const validatePassScore = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('pc_biz_ote_msg_passscorenotnull')));
      } else if (parseInt(value, 0) <= 0 || parseInt(value, 0) > parseInt(vm.ruleForm.totalScore, 0)) {
        callback(new Error(this.$t('pc_biz_ote_msg_passscorelimit')));
      } else {
        callback();
      }
    };
    const validateExScore = (rule, value, callback) => {
      if (value === '') {
      } else if (parseInt(value, 0) < 0 || parseInt(value, 0) > parseInt(vm.ruleForm.totalScore, 0)) {
        callback(new Error(this.$t('pc_biz_ote_msg_exscorelimit')));
      } else {
        callback();
      }
    };
    return {
      value1: '',
      selectExamDrawerData: {
        isShowSelectExamDrawer: false,
        exam: {}
        // examId: '',
        // examName: ''
      },
      selectCerDrawerData: {
        isShowSelectCerDrawer: false,
        cer: {}
        // cerId: '',
        // cerName: ''
      },
      isShowExamSelect: false,
      checkList: [],
      radio: '1',
      attendType: 0,
      touristAttendType: 2,
      isImportant: false,
      isIssueCer: false,
      leaderUserNames: '',
      tracingUserNames: '',
      needCheck: 0,
      status: 0,
      ruleFormStr: '',
      isEntryTimeCtrl: false,
      entryTime: [],
      ruleForm: {
        entryTimeCtrl: 0, // 是否控制考试入场时间
        entryStartTime: '', // 考试入场开始时间
        entryEndTime: '', // 考试入场结束时间
        attendType: 0,
        cerId: '',
        cerName: '',
        description: '',
        examName: '',
        excellenceScore: 0,
        important: 0,
        issueCer: 0,
        listLeaderId: [],
        listTracingUserId: [],
        leaderUsers: [],
        tracingUsers: [],
        passScore: 0,
        passedCredit: 0,
        passedPoint: 0,
        passedStudyHours: 0,
        totalScore: 0,
        type: 0,
        examId: '',
        name: '',
        touristPwd: '',
        isPassedCredit: false,
        isPassedPoint: false
      },
      rules: {
        entryTime: [
          { required: false, validator: validateExamTime, trigger: 'blur' }
        ],
        // 中文校验
        name: [
          { required: true, message: this.$t('pc_biz_ote_msg_examnamenotnull'), trigger: 'blur' }
        ],
        examName: [
          { required: true, message: this.$t('pc_biz_ote_msg_exampapernotnull'), trigger: 'blur' }
        ],
        passScore: [
          { required: true, validator: validatePassScore, trigger: 'blur' }
        ],
        excellenceScore: [
          { required: false, validator: validateExScore, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    oteCerStatus() {
      return getFunStatus(enmuFunctions.EXAM_CERTIFICATE_GET);
    }
  },
  created() {
    this.ruleForm.masterId = this.masterId;
    // this.ruleForm.masterName = this.masterName;
    this.ruleForm.type = this.masterType;
    this.ruleFormStr = JSON.stringify(this.ruleForm);
  },
  methods: {
    saveCerSelect() {
      if (!this.selectCerDrawerData.cer || !this.selectCerDrawerData.cer.id) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_cernotnull')
        });
        return;
      }
      this.selectCerCallback(this.selectCerDrawerData.cer);
      this.closeSelectCerDrawer();
    },
    cancleCerSelect() {
      this.closeSelectCerDrawer();
    },
    saveExamSelect(isClose) {
      // if (!this.selectExamDrawerData.exam || !this.selectExamDrawerData.exam.id) {
      //   if (isClose) {
      //     this.$message({
      //       type: 'warning',
      //       message: '请选择试卷'
      //     });
      //   }
      //   return;
      // }
      this.selectExamCallback(this.selectExamDrawerData.exam);
      if (isClose || this.selectExamDrawerData.exam) {
        this.closeSelectExamDrawer();
      }
    },
    cancleExamSelect() {
      this.closeSelectExamDrawer();
    },
    changeCheckBox(val) {
      console.log(val);
    },
    // 打开选择试卷抽屉
    openSelectExamDrawer() {
      this.selectExamDrawerData.isShowSelectExamDrawer = true;
      this.selectExamDrawerData.exam = {
        id: this.ruleForm.examId,
        name: this.ruleForm.examName,
        totalScore: this.ruleForm.totalScore
      };
    },
    // 关闭快速建题抽屉
    closeSelectExamDrawer() {
      this.selectExamDrawerData.isShowSelectExamDrawer = false;
    },
    // 选择试卷回调方法
    selectExamCallback(exam) {
      if (exam) {
        this.ruleForm.examId = exam.id;
        this.ruleForm.examName = exam.name;
        this.ruleForm.totalScore = exam.totalScore;
        this.$emit('needCheckChange', exam.needCheck);
      } else {
        this.ruleForm.examId = '';
        this.ruleForm.examName = '';
        this.ruleForm.totalScore = 0;
        this.$emit('needCheckChange', 0);
      }
      this.$refs.ruleForm.validate();
    },
    // 打开选择证书抽屉
    openSelectCerDrawer() {
      this.selectCerDrawerData.isShowSelectCerDrawer = true;
      this.selectCerDrawerData.cer = {
        id: this.ruleForm.cerId,
        name: this.ruleForm.cerName
      };
    },
    // 关闭选择证书抽屉
    closeSelectCerDrawer() {
      this.selectCerDrawerData.isShowSelectCerDrawer = false;
    },
    // 选择证书回调方法
    selectCerCallback(cer) {
      this.ruleForm.cerId = cer.id;
      this.ruleForm.cerName = cer.name;
    },
    showDialog() {
      this.selectUsersDialogData.dialogVisible = true;
    },
    checkForm() {
      if (this.ruleForm.isPassedCredit) {
        if (this.ruleForm.passedCredit === '') {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_studyscorenotnull')
          });
          return false;
        }
        if (parseInt(this.ruleForm.passedCredit, 10) <= 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_studyscorelimit')
          });
          return false;
        }
      }
      if (this.ruleForm.isPassedPoint) {
        if (this.ruleForm.passedPoint === '') {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_integralnotnull')
          });
          return false;
        }
        if (parseInt(this.ruleForm.passedPoint, 10) <= 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_integrallimit')
          });
          return false;
        }
      }
      if (this.isIssueCer && !this.ruleForm.cerId) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_cernotnull')
        });
        return false;
      }
      return true;
    },
    submitForm(isNext, isSave) {
      let isCheckOk = false;
      this.$refs['ruleForm'].validate((valid) => {
        let isCheckedSuccess = false;
        if (!valid) {
          this.$message({
            type: 'error',
            message: this.$t('pc_biz_ote_msg_checkinput')
          });
        } else {
          isCheckedSuccess = this.checkForm();
        }
        if (valid && isCheckedSuccess) {
          this.getFormData();
          isCheckOk = true;
          if (!isSave) {
            this.$emit('next');
          }
        } else {
          return false;
        }
      });
      if (isCheckOk) {
        return this.ruleForm;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 加载表单信息
    loadFormData() {
      this.isEntryTimeCtrl = this.ruleForm.entryTimeCtrl === 1;
      this.entryTime = [];
      if (this.ruleForm.entryStartTime && this.ruleForm.entryEndTime) {
        this.entryTime = [ this.ruleForm.entryStartTime, this.ruleForm.entryEndTime ];
      }
      // 是否重要
      this.isImportant = this.ruleForm.important === 1;
      // 积分
      this.ruleForm.isPassedCredit = this.ruleForm.passedCredit > 0;
      // 学分
      this.ruleForm.isPassedPoint = this.ruleForm.passedPoint > 0;
      // 证书
      this.isIssueCer = this.ruleForm.issueCer === 1;
      if (this.ruleForm.attendType === 2 || this.ruleForm.attendType === 3) {
        this.touristAttendType = this.ruleForm.attendType;
        this.attendType = -1;
      } else {
        this.attendType = this.ruleForm.attendType;
      }
      if (this.ruleForm.leaderUsers) {
        this.leaderUserNames = this.ruleForm.leaderUsers.map(function(v) { return v.fullname; }).join(';');
      }
      if (this.ruleForm.tracingUsers) {
        this.tracingUserNames = this.ruleForm.tracingUsers.map(function(v) { return v.fullname; }).join(';');
      }
      // 处理要素功能的状态及属性重置
      if (this.status === 0) {
        this.isIssueCer && resetValueBystatus(enmuFunctions.EXAM_CERTIFICATE_GET, () => { this.isIssueCer = false; });
      }
    },
    // 获取表单数据
    getFormData() {
      this.ruleForm.entryTimeCtrl = this.isEntryTimeCtrl ? 1 : 0;
      this.ruleForm.entryStartTime = '';
      this.ruleForm.entryEndTime = '';
      if (this.isEntryTimeCtrl) {
        this.ruleForm.entryTime = [];
        this.ruleForm.entryStartTime = this.entryTime[0];
        this.ruleForm.entryEndTime = this.entryTime[1];
      }
      if (!this.ruleForm.isPassedCredit) {
        this.ruleForm.passedCredit = 0;
      }
      if (!this.ruleForm.isPassedPoint) {
        this.ruleForm.passedPoint = 0;
      }
      this.ruleForm.issueCer = this.isIssueCer ? 1 : 0;
      this.ruleForm.important = this.isImportant ? 1 : 0;
      if (this.attendType === -1) {
        this.ruleForm.attendType = this.touristAttendType;
      } else {
        this.ruleForm.attendType = this.attendType;
      }
      if (this.ruleForm.leaderUsers) {
        this.ruleForm.listLeaderId = this.ruleForm.leaderUsers.map(function(v) { return v.id; });
      }
      if (this.ruleForm.tracingUsers) {
        this.ruleForm.listTracingUserId = this.ruleForm.tracingUsers.map(function(v) { return v.id; });
      }

      this.ruleForm.passedCredit = parseInt(this.ruleForm.passedCredit, 0);
      this.ruleForm.passedPoint = parseInt(this.ruleForm.passedPoint, 0);
      this.ruleForm.passScore = parseFloat(this.ruleForm.passScore, 0);
      this.ruleForm.excellenceScore = parseFloat(this.ruleForm.excellenceScore, 0) || 0;
    },
    // 删除选择的试卷
    deleteExam() {
      this.ruleForm.examId = '';
      this.ruleForm.examName = '';
      this.maxScore = 0;
    },
    // 删除选择的证书
    deleteCer() {
      this.ruleForm.cerId = '';
      this.ruleForm.cerName = '';
    },
    checkChange() {
      this.getFormData();
      let ruleFormStrNew = JSON.stringify(this.ruleForm);
      return this.ruleFormStr !== ruleFormStrNew;
    }
  },
  watch: {
    arrange(res) {
      this.needCheck = res.needCheck;
      this.status = res.status;
      for (let key in this.ruleForm) {
        if (res.hasOwnProperty(key)) {
          this.ruleForm[key] = res[key];
        }
      }
      this.loadFormData();
      this.ruleFormStr = JSON.stringify(this.ruleForm);
    }
  },
  directives: {
    'enter-number': el => {
      el.onkeyup = () => {
        if (el.nodeName === 'INPUT' && el.type === 'text') {
          if (el.value) {
            el.value = el.value.replace(/[^\d]/g, '');
          }
        } else {
          if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
            let val = document.activeElement.value;
            if (val) {
              document.activeElement.value = val.replace(/[^\d]/g, '');
            }
          }
        }
      };
    },
    'enter-float': el => {
      el.onkeyup = () => {
        if (el.nodeName === 'INPUT' && el.type === 'text') {
          let val = el.value;
          let reg = new RegExp('^[\\d]*\\.?\\d{0,1}$');
          if (val && !reg.test(val)) {
            if (el.attributes['data_val']) {
              val = el.attributes['data_val'].nodeValue;
            } else {
              val = '';
            }
          }
          el.value = val;
          el.setAttribute('data_val', val);
        } else {
          if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
            let val = document.activeElement.value;
            let reg = new RegExp('^[\\d]*\\.?\\d{0,1}$');
            if (val && !reg.test(val)) {
              if (document.activeElement.attributes['data_val']) {
                val = document.activeElement.attributes['data_val'].nodeValue;
              } else {
                val = '';
              }
            }
            document.activeElement.value = val;
            document.activeElement.setAttribute('data_val', val);
          }
        }
      };
    }
  }
};
</script>
